<template>
  <div class="monitor-partner">
    <div class="left_map" style="position: relative">
      <div class="search_dev_box">
        <searchDev
          :options="pointList"
          v-model="activeDevId"
          :setKey="{ key: 'devId', label: 'devName' }"
          @change="checkDevChange"
        ></searchDev>
      </div>
      <div id="container" style="width: 100%; height: 100%"></div>

      <div class="dev_info_tip">
        <span style="font-size: 14px; color: #fff">总数：</span>
        <span style="font-size: 14px" class="baseColor">{{ devNum }}</span>
        <img
          :src="icon1"
          alt=""
          style="width: 25px; height: 30px; margin: 0 10px"
        />
        <span style="font-size: 14px; color: #fff">在线：</span>
        <span style="font-size: 14px" class="baseColor">{{ onlineNum }}</span>
        <img
          :src="icon3"
          alt=""
          style="width: 25px; height: 30px; margin: 0 10px"
        />
        <span style="font-size: 14px; color: #fff">离线：</span>
        <span style="font-size: 14px; color: #999">{{ offlineNum }}</span>
      </div>
    </div>
    <div class="right_tools">
      <div class="right_top box">
        <div class="head_box">
          <div class="head_left">
            <div class="point"></div>
            <div class="title">设备数据</div>
          </div>
          <div class="head_right">
            <span
              >更新时间：{{
                jkblConfig && jkblConfig.date ? jkblConfig.date : "--"
              }}</span
            >
            <span
              class="iconfont icon-shuaxin2 baseColor cp"
              @click="getJKBLConfigList(true)"
            ></span>
            <span
              class="iconfont icon-lishishuju2 baseColor cp"
              @click="showHistory"
            ></span>
          </div>
        </div>
        <div class="content_box top_item">
          <div
            class="content_item d-flex flex-column"
            :class="[isOnline ? 'border_base' : 'border_off']"
            style="position: relative"
            v-if="jkblConfig"
          >
            <div
              class="serve_dev_box"
              :class="[isOnline ? 'b_b_base' : 'b_b_off']"
            >
              <div class="serve_item">
                <span
                  class="iconfont icon-fuwuqi"
                  :class="[isOnline ? 'baseColor' : 'text-888']"
                ></span>
                <span class="font-12">服务器</span>
                <el-tooltip :content="jkblConfig.serverIp" placement="top">
                  <span class="font-12 single-ellipsis"
                    >URL：{{ jkblConfig.serverIp }}</span
                  >
                </el-tooltip>

                <div>
                  <span
                    class="font-14"
                    :class="[isOnline ? 'baseColor' : 'text-888']"
                    >延迟:＜{{
                      jkblConfig.cloudServerResTime == "超时"
                        ? "超时"
                        : jkblConfig.cloudServerResTime
                        ? jkblConfig.cloudServerResTime + "ms"
                        : "0ms"
                    }}</span
                  >
                </div>
              </div>
              <div class="serve_item">
                <span
                  class="iconfont icon-signal"
                  :class="[isOnline ? 'baseColor' : 'text-888']"
                  style="font-size: 38px"
                ></span>
                <span class="font-12">路由器</span>
                <el-tooltip :content="jkblConfig.routerIp" placement="top">
                  <span class="font-12 single-ellipsis"
                    >URL：{{ jkblConfig.routerIp }}</span
                  >
                </el-tooltip>
                <div>
                  <span
                    class="font-14"
                    :class="[isOnline ? 'baseColor' : 'text-888']"
                    >延迟:＜{{
                      jkblConfig.routeResTime == "超时"
                        ? "超时"
                        : jkblConfig.routeResTime
                        ? jkblConfig.routeResTime + "ms"
                        : "0ms"
                    }}</span
                  >
                </div>
              </div>
              <div class="serve_item">
                <span
                  class="iconfont icon-fuwuqi"
                  :class="[isOnline ? 'baseColor' : 'text-888']"
                ></span>
                <span class="font-12">自定义服务器</span>
                <el-tooltip :content="jkblConfig.threeServerIp" placement="top">
                  <span class="font-12 single-ellipsis"
                    >URL：{{ jkblConfig.threeServerIp }}</span
                  >
                </el-tooltip>
                <div>
                  <span
                    class="font-14"
                    :class="[isOnline ? 'baseColor' : 'text-888']"
                    >延迟:＜{{
                      jkblConfig.outNetResTime == "超时"
                        ? "超时"
                        : jkblConfig.outNetResTime
                        ? jkblConfig.outNetResTime + "ms"
                        : "0ms"
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div class="dev_info_box">
              <img :src="!isOnline ? devOnIcon : devOffIcon" alt="" />
              <div class="font-14" style="margin-top: 2px">
                <span>{{ jkblConfig.devName }}</span>
                <span v-if="jkblConfig.deviceIp"
                  >IP:{{ jkblConfig.deviceIp }}</span
                >
              </div>
              <div class="xh_box" style="color: #fff">
                <span
                  class="iconfont icon-xinhao"
                  style="margin-right: 4px; font-size: 12px"
                ></span
                ><span class="font-12">{{ isOnline ? "在线" : "离线" }}</span>
              </div>
            </div>
            <span
              class="iconfont icon-bianji4 cp font-14"
              :class="[isOnline ? 'baseColor' : 'text-888']"
              style="position: absolute; right: 15px; top: 10px"
              @click="setServe"
            ></span>
          </div>
          <div
            class="content_item"
            :class="[isOnline ? 'border_base' : 'border_off']"
            v-else
          >
            <hnEmptyData setType="col" size="80px" text="暂无监控伴侣配置">
              <el-button
                size="mini"
                @click="setServe"
                class="update_primary_but"
                type="primary"
                plain
                >立即配置</el-button
              >
            </hnEmptyData>
          </div>
          <div class="content_item_sub">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <span class="font-14 baseColor">
                  {{
                    jkblConfig && jkblConfig.monitorName
                      ? jkblConfig.monitorName
                      : "视频设备"
                  }}</span
                >
                <span
                  class="iconfont icon-bianji4 baseColor cp font-14"
                  style="margin: 0 6px"
                  @click="setDevName"
                ></span>
                <span class="font-12"
                  >IP:
                  {{
                    jkblConfig && jkblConfig.monitorIp
                      ? jkblConfig.monitorIp
                      : "0.0.0.0"
                  }}</span
                >
              </div>
              <div class="font-12 baseColor">
                延迟:＜{{
                  jkblConfig && jkblConfig.otherDevResTime == "超时"
                    ? "超时"
                    : jkblConfig && jkblConfig.otherDevResTime
                    ? jkblConfig.otherDevResTime + "ms"
                    : "0ms"
                }}
              </div>
            </div>
            <div class="device-control-panel">
              <div class="control-item">
                <span class="label">设备状态:</span>
                <span class="status-text">{{
                  videoStatus ? "开启" : "关闭"
                }}</span>
                <el-switch
                  v-model="videoStatus"
                  @change="videoStatusChange"
                  class="custom-switch"
                  active-color="#00B38A"
                  inactive-color="#4a5568"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </div>
              <div class="control-item">
                <span class="label">设备复位</span>
                <span
                  class="timer"
                  :class="{ 'countdown-active': videoRestartCountdown > 0 }"
                >
                  ({{
                    videoRestartCountdown > 0
                      ? videoRestartCountdown + "s"
                      : "60s"
                  }})
                </span>
                <button
                  class="restart-btn"
                  :class="{ disabled: isVideoRestartDisabled }"
                  :disabled="isVideoRestartDisabled"
                  @click="toVideorestart"
                >
                  {{ isVideoRestartDisabled ? "重启中" : "重启" }}
                </button>
              </div>
            </div>
          </div>
          <div class="content_item_sub">
            <div class="d-flex align-items-center">
              <div class="font-14 baseColor">
                {{
                  jkblConfig && jkblConfig.controlDevcName
                    ? jkblConfig.controlDevcName
                    : "外接设备"
                }}
              </div>
              <span
                class="iconfont icon-bianji4 baseColor cp font-14"
                style="margin: 0 6px"
                @click="setOtherDevName"
              ></span>
            </div>
            <div class="device-control-panel">
              <div class="control-item">
                <span class="label">设备状态:</span>
                <span class="status-text">{{
                  ctlStatus ? "开启" : "关闭"
                }}</span>
                <el-switch
                  v-model="ctlStatus"
                  @change="ctlStatusChange"
                  class="custom-switch"
                  active-color="#00B38A"
                  inactive-color="#4a5568"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </div>
              <div class="control-item">
                <span class="label">设备复位</span>
                <span
                  class="timer"
                  :class="{ 'countdown-active': ctlRestartCountdown > 0 }"
                >
                  ({{
                    ctlRestartCountdown > 0 ? ctlRestartCountdown + "s" : "60s"
                  }})
                </span>
                <button
                  class="restart-btn"
                  :class="{ disabled: isCtlRestartDisabled }"
                  :disabled="isCtlRestartDisabled"
                  @click="toCtlRestart"
                >
                  {{ isCtlRestartDisabled ? "重启中" : "重启" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_center box" v-if="jkblConfig">
        <div class="head_box">
          <div class="head_left">
            <div class="point"></div>
            <div class="title">
              {{
                videoInfo && videoInfo.devName ? videoInfo.devName : "监控设备"
              }}
            </div>
          </div>
          <div class="head_right"></div>
        </div>
        <div class="content_box d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center">
            <div class="font-14">
              <span
                class="iconfont icon-dingwei5 baseColor"
                v-if="jkblConfig && jkblConfig.pointName"
              ></span
              >{{
                jkblConfig && jkblConfig.pointName ? jkblConfig.pointName : ""
              }}
            </div>
            <div :class="[videoOnlineStatus ? 'baseColor' : 'text-888']">
              <span
                class="iconfont icon-xinhao"
                style="margin-right: 4px"
              ></span
              ><span class="font-14">{{
                videoOnlineStatus ? "在线" : "离线"
              }}</span>
            </div>
          </div>
          <div class="video_box border_base">
            <videoPlay :videoInfo="videoInfo" v-if="videoInfo"></videoPlay>
            <hnEmptyData
              setType="col"
              size="80px"
              text="暂无监控设备"
              v-else
            ></hnEmptyData>
          </div>
        </div>
      </div>
      <div class="right_bottom" v-if="listData.length > 0">
        <warnScroll :listData="listData" :devId="activeDevId"></warnScroll>
      </div>
    </div>
  </div>
</template>

<script>
import warnScroll from "./warnScroll.vue";
import setDevInfo from "./setDevInfo.vue";
import setServeInfo from "./setServeInfo.vue";
import historyList from "./historyList.vue";
import transform from "@/libs/transformMap.js";
import AMapLoader from "@amap/amap-jsapi-loader";
import searchDev from "./searchDev.vue";
import setVideoDevInfo from "./setVideoDevInfo.vue";
import videoPlay from "@/components/localComponent/videoPlay.vue";
export default {
  components: {
    warnScroll,
    searchDev,
    videoPlay,
  },
  data() {
    return {
      AMap: null,
      map: null,
      videoStatus: 0,
      ctlStatus: 0,
      // 添加倒计时相关数据
      videoRestartTimer: null,
      ctlRestartTimer: null,
      videoRestartCountdown: 0,
      ctlRestartCountdown: 0,
      devOffIcon: require("@/assets/imgs/monitorPartner/default/icon4.png"),
      devOnIcon: require("@/assets/imgs/monitorPartner/default/icon5.png"),
      listData: [],
      icon1: require("@/assets/imgs/monitorPartner/default/icon1.png"),
      icon2: require("@/assets/imgs/monitorPartner/default/icon2.png"),
      icon3: require("@/assets/imgs/monitorPartner/default/icon3.png"),
      icon8: require("@/assets/imgs/monitorPartner/default/icon8.png"),
      icon6: require("@/assets/imgs/monitorPartner/default/icon6.png"),
      icon7: require("@/assets/imgs/monitorPartner/default/icon7.png"),
      markers: [],
      activeDevId: null,
      pointList: [],
      jkblConfig: null,
      videoInfo: null,
    };
  },
  mounted() {
    this.getDevList();
    // 恢复倒计时状态
    this.restoreCountdownState();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.videoRestartTimer) {
      clearInterval(this.videoRestartTimer);
      this.videoRestartTimer = null;
    }
    if (this.ctlRestartTimer) {
      clearInterval(this.ctlRestartTimer);
      this.ctlRestartTimer = null;
    }
  },
  computed: {
    videoOnlineStatus() {
      return this.videoInfo?.onlineStatus == 9 ? true : false;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isMapLayer() {
      return this.$store.state.user.userInfo?.mapLayer == 0 ? true : false;
    },
    activeDev() {
      return this.pointList.find((item) => item.devId == this.activeDevId);
    },
    isOnline() {
      return this.activeDev?.onlineStatus == 9;
    },
    devNum() {
      return this.pointList.length;
    },
    onlineNum() {
      return this.pointList.filter((item) => item.onlineStatus == 9).length;
    },
    offlineNum() {
      return this.pointList.filter((item) => item.onlineStatus != 9).length;
    },
    // 添加按钮禁用状态计算属性
    isVideoRestartDisabled() {
      return this.videoRestartCountdown > 0;
    },
    isCtlRestartDisabled() {
      return this.ctlRestartCountdown > 0;
    },
  },
  methods: {
    checkDevChange(option) {
      console.log(option, "option");
      this.markers.some((item) => {
        if (item.devId == option.devId) {
          this.setActiveMarker(item);
          return true;
        }
      });
    },
    async getWarnInfo() {
      const res = await this.$api.LogGetDevCodeAlarmPageList({
        devId: this.activeDevId,
        pageSize: 10,
        pageIndex: 1,
      });
      console.log(res);
      this.listData = res?.list || [];
    },
    async toVideorestart() {
      if (this.isVideoRestartDisabled) {
        return;
      }
      try {
        const res = await this.$api.SetIotJKBLRestart({
          devCode: this.jkblConfig.devCode,
        });
        this.$message.success("重启成功");
        // 开始倒计时
        this.startVideoRestartCountdown();
      } catch (error) {
        this.$message.error("重启失败");
      }
    },
    async toCtlRestart() {
      if (this.isCtlRestartDisabled) {
        return;
      }
      try {
        const res = await this.$api.SetIotJKBLExternalRestart({
          devCode: this.jkblConfig.devCode,
        });
        this.$message.success("重启成功");
        // 开始倒计时
        this.startCtlRestartCountdown();
      } catch (error) {
        this.$message.error("重启失败");
      }
    },
    async getVideoInfo() {
      console.log(this.jkblConfig, 44444444);
      const res = await this.$api.IotVideoDeviceDataList({
        code: this.jkblConfig.videoCode,
      });
      this.videoInfo = res;
    },
    async getJKBLConfigList(isRefresh = false) {
      const res = await this.$api.JKBLConfigDetalist({ id: this.activeDevId });
      let data = res && res.hasOwnProperty("data") ? res.data : res;
      this.jkblConfig = data || null;
      this.videoStatus = data?.videoOpen;
      this.ctlStatus = data?.controOpen;
      if (data.videoCode) {
        this.getVideoInfo();
      }
      if (isRefresh) {
        this.getWarnInfo();
        this.$message.success("刷新成功");
      }
    },
    async getDevList() {
      const res = await this.$api.IotEntAreaDeviceList({ devTypes: ["1016"] });

      console.log(res);
      let list = res || [];
      let pointList = [];
      list.map((item) => {
        if (item.devs && item.devs.length > 0) {
          item.devs.map((dev) => {
            pointList.push(dev);
          });
        }
      });
      this.pointList = pointList;
      this.$nextTick(() => {
        this.mapInit(list);
      });
    },
    mapInit(list) {
      let aMapKey = this.$store.state.user.amapKey;
      window.forceWebGL = true;
      AMapLoader.load({
        key: aMapKey.gdKey, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.GltfLoader", "AMap.MoveAnimation"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: "2.0", // Loca 版本，缺省 1.3.2
        },
        // AMapUI: {
        //   version: '1.1',
        //   plugins:['overlay/SimpleMarker']
        // },
      })
        .then((AMap) => {
          console.log(AMap);
          this.AMap = AMap;
          let lngLat = this.userInfo
            ? transform.gTw(this.userInfo.lng, this.userInfo.lat)
            : [];
          // lngLat = transform.gTw(100.990626, 37.083374);
          let map = new AMap.Map("container", {
            zoom: 16,
            pitch: 40,
            viewMode: "3D",
            center: lngLat,
            // zoom: 15.5,
            // center: lngLat,
          });
          this.map = map;
          // map.on("click", (e) => {
          // console.log(e);
          // });
          if (!lngLat) this.getIpPosition(AMap);

          if (this.isMapLayer) {
            let aMapKey = this.$store.state.user.amapKey;
            let wms = new AMap.TileLayer.WMTS({
              url: aMapKey.tdUrl || "",
              blend: false,
              titleSize: 256,
              params: {
                Layer: "img",
                Version: "1.0.0",
                Format: "tiles",
                TileMatrixSet: "w",
                STYLE: "default",
                tk: aMapKey.tdKey || "",
              },
            });
            wms.setMap(map);
          }
          this.setMarket();
          this.setPolygon(list);
        })
        .catch((e) => {});
    },
    setPolygon(areaList) {
      let AMap = this.AMap;
      areaList.map((item) => {
        new AMap.Polygon({
          strokeColor: "#FFF",
          strokeOpacity: 1,
          strokeWeight: 2,
          strokeOpacity: 0.4,
          fillColor: item.mapColor,
          fillOpacity: 0.4,
          strokeStyle: "solid",
          map: this.map,
          path: JSON.parse(item.mapPoints),
        });
      });
    },
    // 设置market
    setMarket() {
      let AMap = this.AMap;
      if (this.markers.length) {
        this.map.remove(this.markers);
        this.markers = [];
      }
      this.pointList.map((item) => {
        if (!item.lng || !item.lat) return;

        var marker = new AMap.Marker({ zIndex: 120 });
        // [item.lng,item.lat] transform.gTw(104.063321,30.594767) transform.gTw(item.lng,item.lat)
        let lngLat = transform.gTw(item.lng, item.lat);
        let startIcon = this.setIcon(item);
        marker.setPosition(lngLat);
        marker.setMap(this.map);
        marker.setIcon(startIcon);
        marker.devId = item.devId;
        marker.dataInfo = item;
        marker.isActive = false;
        marker.lngLat = lngLat;
        this.markers.push(marker);
        if (this.markers.length) {
          this.setActiveMarker(this.markers[0]);
        }
        marker.on("click", (e) => {
          if (marker.isActive) return;
          this.setActiveMarker(e.target);
          let point = this.isPoint(e);
          this.map.setCenter(point);
        });
      });
    },
    setIcon(item) {
      let icon = null;
      if (item.onlineStatus == 9) {
        icon = item.isAlarm ? this.icon7 : this.icon1;
      } else {
        icon = item.isAlarm ? this.icon8 : this.icon3;
      }

      // 创建一个 Icon
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(30, 36),
        // 图标的取图地址
        image: icon,
        // 图标所用图片大小
        imageSize: new AMap.Size(30, 36),
      });
      return startIcon;
    },
    setActiveMarker(marker) {
      this.markers.map((subMarker) => {
        if (subMarker.isActive) {
          let startIcon = this.setIcon(subMarker.dataInfo);
          subMarker.setIcon(startIcon);
          subMarker.isActive = false;
        }
        if (subMarker.devId == marker.devId) {
          let icon = subMarker.dataInfo.isAlarm ? this.icon6 : this.icon2;
          // 创建一个 Icon
          var startIcon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(36, 43),
            // 图标的取图地址
            image: icon,
            // 图标所用图片大小
            imageSize: new AMap.Size(36, 43),
          });

          subMarker.setIcon(startIcon);
          subMarker.isActive = true;
        }
      });
      this.map.setCenter(marker.lngLat);
      this.activeDevId = marker.devId;
      this.getJKBLConfigList();
      this.getWarnInfo();
    },
    isPoint(e) {
      const allWidth = document.body.clientWidth;
      let times = 1920 / allWidth;
      let pixelarr = e.pixel.toArray();

      var pixel = new this.AMap.Pixel(pixelarr[0] * times, pixelarr[1] * times);
      var lnglat = this.map.containerToLngLat(pixel);

      if (lnglat) return lnglat;
    },
    // 获取ip定位信息
    getIpPosition(AMap) {
      AMap.plugin("AMap.Geolocation", function () {
        new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量
          offset: [10, 20],
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          position: "RB",
        });
      });
    },
    async videoStatusChange(value) {
      if (!this.isOnline) {
        this.videoStatus = value == 0 ? 1 : 0;
        return this.$message.warning("设备离线，无法控制");
      }
      try {
        const res = await this.$api.SetIotJKBLControl({
          devCode: this.jkblConfig.devCode,
          openType: value,
        });
        this.$message.success("控制成功");
      } catch (e) {
        console.log(e);
        this.$message.warning("控制失败");
        this.videoStatus = value == 0 ? 1 : 0;
      }
    },
    async ctlStatusChange(value) {
      if (!this.isOnline) {
        this.ctlStatus = value == 0 ? 1 : 0;
        return this.$message.warning("设备离线，无法控制");
      }
      try {
        const res = await this.$api.SetIotJKBLExternalControl({
          devCode: this.jkblConfig.devCode,
          openType: value,
        });
        this.$message.success("控制成功");
      } catch (e) {
        console.log(e);
        this.$message.warning("控制失败");
        this.ctlStatus = value == 0 ? 1 : 0;
      }
    },
    setDevName() {
      this.showDialog(
        setVideoDevInfo,
        {
          props: {
            row: this.jkblConfig,
            devId: this.activeDevId,
          },
        },
        {
          width: "500px",
          title: "视频设备频备",
          dialog: {
            isCenter: true,
          },
        },
        () => {
          this.getJKBLConfigList();
        }
      );
    },
    setOtherDevName() {
      this.showDialog(
        setDevInfo,
        {
          props: {
            row: this.jkblConfig,
            devId: this.activeDevId,
          },
        },
        {
          width: "400px",
          title: "外接设备频备",
          dialog: {
            isCenter: true,
          },
        },
        () => {
          this.getJKBLConfigList();
        }
      );
    },
    setServe() {
      // 上线放开
      if (!this.isOnline) return this.$message.warning("设备离线，无法编辑");
      this.showDialog(
        setServeInfo,
        {
          props: {
            row: this.jkblConfig,
            devId: this.activeDevId,
          },
        },
        {
          width: "600px",
          title: "编辑",
          dialog: {
            isCenter: true,
          },
        },
        () => {
          this.getJKBLConfigList();
        }
      );
    },
    showHistory() {
      console.log(this.jkblConfig.devCode);
      this.showDialog(
        historyList,
        { props: { devCode: this.jkblConfig.devCode } },
        {
          width: "1000px",
          title: "历史记录",
          dialog: {
            isBut: false,
            isCenter: true,
          },
        }
      );
    },
    // 倒计时相关方法
    startVideoRestartCountdown(initialCount = 60) {
      this.videoRestartCountdown = initialCount;
      this.saveCountdownState();

      this.videoRestartTimer = setInterval(() => {
        this.videoRestartCountdown--;
        this.saveCountdownState();

        if (this.videoRestartCountdown <= 0) {
          clearInterval(this.videoRestartTimer);
          this.videoRestartTimer = null;
          this.videoRestartCountdown = 0;
          this.saveCountdownState();
        }
      }, 1000);
    },

    startCtlRestartCountdown(initialCount = 60) {
      this.ctlRestartCountdown = initialCount;
      this.saveCountdownState();

      this.ctlRestartTimer = setInterval(() => {
        this.ctlRestartCountdown--;
        this.saveCountdownState();

        if (this.ctlRestartCountdown <= 0) {
          clearInterval(this.ctlRestartTimer);
          this.ctlRestartTimer = null;
          this.ctlRestartCountdown = 0;
          this.saveCountdownState();
        }
      }, 1000);
    },

    saveCountdownState() {
      const state = {
        videoRestartCountdown: this.videoRestartCountdown,
        ctlRestartCountdown: this.ctlRestartCountdown,
        timestamp: Date.now(),
      };
      localStorage.setItem("monitorPartnerCountdown", JSON.stringify(state));
    },

    restoreCountdownState() {
      try {
        const savedState = localStorage.getItem("monitorPartnerCountdown");
        if (savedState) {
          const state = JSON.parse(savedState);
          const now = Date.now();
          const elapsed = Math.floor((now - state.timestamp) / 1000);

          // 恢复视频重启倒计时
          if (state.videoRestartCountdown > 0) {
            const remainingTime = Math.max(
              0,
              state.videoRestartCountdown - elapsed
            );
            if (remainingTime > 0) {
              this.startVideoRestartCountdown(remainingTime);
            }
          }

          // 恢复控制重启倒计时
          if (state.ctlRestartCountdown > 0) {
            const remainingTime = Math.max(
              0,
              state.ctlRestartCountdown - elapsed
            );
            if (remainingTime > 0) {
              this.startCtlRestartCountdown(remainingTime);
            }
          }
        }
      } catch (error) {
        console.error("恢复倒计时状态失败:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.monitor-partner {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  .left_map {
    flex: 1;
    height: 100%;
    min-width: 0px;
    margin-right: 10px;
  }
  .right_tools {
    width: 462px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .right_top {
      height: 440px;
      .top_item {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .content_item {
        height: 220px;
        border-radius: 10px;
        flex: 1;
        min-height: 0px;
        max-height: 220px;
      }
      .content_item_sub {
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 1px solid #00b38a;
        max-height: 70px;
      }

      .device-control-panel {
        display: flex;

        gap: 15px;
        margin-top: 4px;

        .control-item {
          display: flex;
          align-items: center;
          gap: 10px;

          .label {
            font-size: 14px;
            color: #fff;
            white-space: nowrap;
          }

          .status-text {
            font-size: 14px;
            color: #fff;
            margin-right: 10px;
          }

          .custom-switch {
            ::v-deep .el-switch__core::after {
              width: 20px !important;
              height: 20px !important;
              top: 0px !important;
            }
            ::v-deep .el-switch__core {
              width: 40px !important;
              height: 20px !important;
              border-radius: 10px !important;
              background-color: #4a5568 !important;
              border: none !important;
            }

            ::v-deep .el-switch__button {
              width: 12px !important;
              height: 12px !important;
              border-radius: 50% !important;
              background-color: #cbd5e0 !important;
              border: none !important;
              top: 4px !important;
              left: 4px !important;
            }

            &.is-checked {
              ::v-deep .el-switch__core {
                background-color: #00b38a !important;
              }

              ::v-deep .el-switch__button {
                transform: translateX(20px) !important;
              }
            }
          }

          .timer {
            font-size: 14px;
            color: #00b38a;
            margin-left: 5px;
            transition: color 0.3s ease;

            &.countdown-active {
              color: #ff6b6b;
              font-weight: bold;
            }
          }

          .restart-btn {
            background-color: #00b38a;
            color: #fff;
            border: none;
            border-radius: 6px;
            padding: 0px 12px;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover:not(.disabled) {
              background-color: #009973;
            }

            &.disabled {
              background-color: #6c757d;
              cursor: not-allowed;
              opacity: 0.7;
            }
          }
        }
      }
      .serve_dev_box {
        flex: 1;
        min-height: 0px;
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        .serve_item {
          flex: 1;
          min-width: 0px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          .iconfont {
            font-size: 36px;
          }
        }
      }

      .dev_info_box {
        height: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .xh_box {
          position: absolute;
          top: 8px;
          right: 135px;
        }
        & > img {
          width: 198px;
          height: 50px;
        }
      }
    }
    .flex_1 {
      flex: 1;
      min-height: 0px;
    }
    .right_center {
      flex: 1;
      min-height: 0px;
      .video_box {
        flex: 1;
        margin-top: 10px;
        min-height: 0px;
      }
    }
    .right_bottom {
      height: 32px;
      background-color: #28353f;
    }
    .head_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      background: rgba(#00d1a1, 0.7);
      color: #fff;
      padding: 0 10px;
      box-sizing: border-box;
      .head_left {
        display: flex;
        align-items: center;
        .point {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 1px solid #ff9000;
          position: relative;
        }
        .point::after {
          content: "";
          display: block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ff9000;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .title {
          font-size: 16px;
          font-weight: 600;
          margin-left: 10px;
        }
      }
      .head_right {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        .iconfont {
          font-size: 16px;
        }
      }
    }
    .box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .content_box {
        flex: 1;
        min-height: 0px;
        background: #28353f;
        padding: 20px;
        box-sizing: border-box;
      }
    }
  }
}
.dev_info_tip {
  display: flex;
  align-items: center;

  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(#15232d, 0.7);
  box-shadow: 0px 2px 2px 0px rgba(120, 120, 120, 0.08);
  border-radius: 5px;
  padding: 5px 10px;
}
.search_dev_box {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 210px;
  z-index: 1000;
}

.b_b_base {
  border-bottom: 1px solid #00b38a;
}
.border_base {
  border: 1px solid #00b38a;
}
.b_b_off {
  border-bottom: 1px solid #999999;
}
.border_off {
  border: 1px solid #999999;
}
</style>